import { refreshToken } from "./auth/auth";

const defaultErrors: Record<number, string> = {
  400: "اطلاعات ارسال شده مناسب نیستند.",
  401: "توکن نامعتبر است!",
  402: "این فرایند نیازمند پرداخت است.",
  403: "شما مجاز به انجام این فرایند نیستید!",
  404: "مقداری با این مشخصات وجود ندارد!",
  405: "روش ارسالی صحیح نیست، لطفا به ما اطلاع  دهید.",
  408: "فرایند بیشتر از زمان لازم طول کشیده است، امکان ادامه وجود ندارد.",
  409: "وجود تداخل در اطلاعات، امکان انجام فرایند وجود ندارد.",
  410: "درخواست شما خارج از زمان تعیین شده است.",
  413: "حجم داده دریافتی بیش از حد مجاز است!",
  415: "فایل ارسالی فرمت مناسب را ندارد",
  429: "خطا، درخواست‌های خیلی زیاد!",
  500: "متاسفانه خطایی در برنامه رخ داده است، لطفا دوباره تلاش کنید یا به ما اطلاع دهید",
};

export const catchHandler = async <OutPut>(
  error: any,
  data: any,
  fn: (payload: any) => Promise<unknown>,
  message: Record<number, string | undefined>,
  refresh = true,
): Promise<OutPut | string | undefined> => {
  const errorResponse = { ...defaultErrors, ...message };

  if (error.hasOwnProperty("response")) {
    if (error.response.status === 401 && refresh) {
      // Handle refresh token!
      const result = await refreshToken();
      if (!result) {
        localStorage.clear();
        sessionStorage.clear();
        (window as Window).location.replace("/");
        return undefined;
      }

      sessionStorage.setItem(
        process.env.REACT_APP_TOKEN as string,
        result!.token,
      );
      return (await fn(data)) as OutPut;
    }
    if (error.response.status === 400) {
      if (
        error.response.data &&
        error.response.data.error &&
        error.response.data.error.name &&
        error.response.data.error.name === "ZodError"
      ) {
        return "اطلاعات وارد شده صحیح نیستند، لطفا این مورد را به ما گزارش کنید.";
      }
      return errorResponse[400];
    }

    switch (error.response.status) {
      case 401:
        return errorResponse[401];
      case 402:
        return errorResponse[402];
      case 403:
        return errorResponse[403];
      case 404:
        return errorResponse[404];
      case 405:
        return errorResponse[405];
      case 408:
        return errorResponse[408];
      case 409:
        return errorResponse[409];
      case 410:
        return errorResponse[410];
      case 413:
        return errorResponse[413];
      case 415:
        return errorResponse[415];
      case 429:
        return errorResponse[429];
      case 500:
        return errorResponse[500];
    }
  } else if (error.hasOwnProperty("request")) {
    console.log(error.request);
  } else {
    console.log("Error", error);
  }
  return undefined;
};
